export default function About() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Video */}
          <div className="rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl">
            <div className="w-full h-80 md:h-96 lg:h-[500px]">
              <iframe 
                allow="fullscreen;autoplay" 
                allowFullScreen 
                height="100%" 
                src="https://streamable.com/e/48zc4a?autoplay=1&muted=1&nocontrols=1" 
                width="100%" 
                style={{ border: 'none', width: '100%', height: '100%', pointerEvents: 'none' }}
                title="Le Bocal Givré - Vidéo"
                sandbox="allow-scripts allow-same-origin allow-presentation"
                loading="lazy"
              />
            </div>
          </div>

          {/* Content */}
          <div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#4A7C59] mb-4 md:mb-6" style={{ fontFamily: 'Pacifico, cursive' }}>
              À Propos
            </h2>
            
            <div className="space-y-4 md:space-y-6 text-base md:text-lg text-gray-700 leading-relaxed">
              <p className="text-xl md:text-2xl font-semibold text-[#FF8F6B]">
                Nouvelle équipe, même passion ! 🎉
              </p>
              
              <p>
                Nouveaux propriétaires motivés pour reprendre le flambeau de cet établissement reconnu avec plus de 10K abonnés sur Instagram.
              </p>

              <p>
                Le Bocal Givré, c'est avant tout un <strong>concept unique</strong> : une cuisine locale et internationale, maison, dans un cadre verdoyant exceptionnel à Saint-Pierre, La Réunion.
              </p>

              <p>
                Notre mission ? Créer des <strong>moments de partage authentiques</strong> autour de plats savoureux et généreux, dans une ambiance tropicale-chic et décontractée.
              </p>

              <div className="bg-[#F5E6D3] rounded-xl md:rounded-2xl p-5 md:p-6 mt-6 md:mt-8">
                <p className="text-lg md:text-2xl font-bold text-[#4A7C59] text-center">
                  @lebokalgivre on aime vous faire plaisir 🍍🍍🍍
                </p>
              </div>

              <div className="flex flex-wrap gap-3 md:gap-4 mt-6 md:mt-8">
                <div className="flex items-center gap-2 bg-[#4A7C59]/10 px-3 md:px-4 py-2 rounded-full">
                  <span className="text-xl md:text-2xl">✨</span>
                  <span className="font-semibold text-[#4A7C59] text-sm md:text-base">Cuisine maison</span>
                </div>
                <div className="flex items-center gap-2 bg-[#4A7C59]/10 px-3 md:px-4 py-2 rounded-full">
                  <span className="text-xl md:text-2xl">🌴</span>
                  <span className="font-semibold text-[#4A7C59] text-sm md:text-base">Cadre verdoyant</span>
                </div>
                <div className="flex items-center gap-2 bg-[#4A7C59]/10 px-3 md:px-4 py-2 rounded-full">
                  <span className="text-xl md:text-2xl">❤️</span>
                  <span className="font-semibold text-[#4A7C59] text-sm md:text-base">Moments de partage</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
